export class FormItemBase<T> {
    itemType: string;
    value: any;
    key: string;
    label: string;
    shortlabel: string;
    altlabel: string;
    comment: string;
    required: boolean;
    order: number;
    controlType: string;
    depth: number;
    isVisible: boolean;
    isEnabled: boolean;
    isReadOnly: boolean;
    invalidValue: boolean;
    useAltText: boolean;
    labelClass: string;
    fieldClass: string;
    //fgColorHint: string;
    showCopy: boolean;
    showValidate: boolean;
    tooltipBody: string;
    tooltipLink: string;
    tooltipImage: string;
    options: any;
    isTooltipDefined: boolean;
    selectedLabel: string;
    boolValue: boolean;
    minValue: number;
    maxValue: number;
    errorHint: string;
    widthHint: any;
    heightHint: any;
    optionStrs: any;
    bWorksheetWarningsExist: boolean;
    bWorksheetErrorsExists: boolean;
    children: any;
    icon: any;
    alertMessage: any;

    constructor(options: {
        itemType?: string,
        value?: any,
        key?: string,
        label?: string,
        shortlabel?: string,
        altlabel?: string,
        comment?: string,
        required?: boolean,
        order?: number,
        controlType?: string,
        depth?: number,
        isVisible?: boolean,
        isReadOnly?: boolean,
        isEnabled?: boolean,
        useAltText?: boolean,
        isTooltipDefined?: boolean,
        invalidValue?: boolean,
        minValue?: number,
        maxValue?: number,
        boolValue?: boolean,
        errorHint?: string,
        bWorksheetErrorsExist?: boolean,
        bWorksheetWarningsExist?: boolean;
      } = {}) {
      this.itemType = options.itemType;
      this.value = options.value;
      this.key = options.key || '';
      this.label = options.label || '';
      this.shortlabel = options.shortlabel || '';
      this.altlabel = options.altlabel || '';
      this.comment = options.comment || '';
      this.required = !!options.required;
      this.order = options.order === undefined ? 1 : options.order;
      this.controlType = options.controlType || '';
      this.depth = options.depth === undefined ? 0 : options.depth;
      this.isVisible = options.isVisible || true;
      this.isReadOnly = options.isReadOnly || true;
      this.isEnabled = options.isEnabled || true;
      this.invalidValue = options.invalidValue || false;
      this.useAltText = options.useAltText || false;
      this.isTooltipDefined = options.isTooltipDefined || false;
      this.minValue = options.minValue || 0;
      this.maxValue = options.maxValue || 0;
      this.boolValue = options.boolValue || false;
      this.errorHint = options.errorHint || '';
      this.bWorksheetErrorsExists = options.bWorksheetErrorsExist || false;
      this.bWorksheetWarningsExist = options.bWorksheetWarningsExist || false;

      this.selectedLabel = this.label;

      if (this.useAltText && (this.altlabel.length > 0)) {
        this.selectedLabel = this.altlabel;
      }
    }
  }
